import { render } from "./IconDescend.vue?vue&type=template&id=4114102c"
import script from "./IconDescend.vue?vue&type=script&lang=js"
export * from "./IconDescend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__